<template>
    <div class="requirement-container">
        <div class="requirement-create-container">
            <div class="requirement-create-text">
                <h2>云企业顾问</h2>
                <p>为您一对一解决问题</p>
            </div>
            <a
                class="require-submit"
                @click="onShowDialog"
            >提交需求</a>
        </div>
        <div class="relation-container">
            <h2>
                <span>关联服务</span>
            </h2>
            <a
                v-for="(item, index) in service"
                :key="index"
                :class="['relation-service', index !== service.length - 1 ? 'last-service' : '']"
                :href="item.url"
                target="_blank"
            >
                <div class="relation-service-container">
                    <img :src="item.img" :class="['service-icon', item.link === 'crs' ? 'smaller-icon' : '']"/>
                    <div class="relation-service-content">
                        <p class="title">{{ item.title }}</p>
                        <p class="des">{{ item.des }}</p>
                        <p class="price">￥{{ item.price }}起</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>

import {requirementDatasource} from '../pages/data/global';

export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        regionDatasource: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            service: requirementDatasource[this.type]
        };
    },
    methods: {
        onShowDialog() {
            this.$emit('onClickSubmit', true);
        }
    }
};
</script>

<style lang="less" scoped>
.requirement-container {
    width: 254px;
    position: absolute;
    right: 0;
    top: 0;
    .requirement-create-container {
        width: 100%;
        height: 110px;
        padding: 0 16px;
        background: url(../assets/requirement_bac.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .require-submit {
        width: 70px;
        height: 25px;
        background: #fff;
        border-radius: 13px;
        font-size: 12px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: #2468f2;
        display: block;
        cursor: pointer;
    }
    .requirement-create-text {
        h2 {
            height: 25px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 25px;
            color: #ffffff;
            margin-bottom: 8px;
        }
        p {
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #ffffff;
        }
    }
    .relation-container {
        height: 410px;
        background-color: #fff;
        margin-top: 16px;
        padding: 20px 10px 0;
        h2 {
            height: 25px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 25px;
            color: #191c3d;
            text-align: center;
            margin-bottom: 4px;
            span {
                display: inline-block;
                position: relative;
            }
            span:before {
                content: '';
                width: 56px;
                height: 3px;
                background: linear-gradient(270deg, #459bff 0%, rgba(0, 108, 255, 0) 100%);
                border-radius: 2px;
                display: block;
                position: absolute;
                left: -64px;
                top: 10px;
            }
            span:after {
                content: '';
                width: 56px;
                height: 3px;
                background: linear-gradient(90deg, #459bff 0%, rgba(0, 108, 255, 0) 100%);
                border-radius: 2px;
                display: block;
                position: absolute;
                right: -64px;
                top: 10px;
            }
        }
    }
    .line {
        height: 1px;
        background-color: #dddddd;
        margin: 16px 0;
    }
    .last-service {
        border-bottom: 1px dashed #ddd;
    }
    .relation-service {
        padding: 16px 0;
        .relation-service-container {
            display: flex;
            justify-content: flex-start;
            cursor: pointer;
            margin-bottom: 20px;

            &:first-child {
                margin-top: 20px;
            }
        }
        .relation-service-container:hover {
            .title {
                color: #2468f2;
            }
        }

        .service-icon {
            flex-shrink: 0;
            display: block;
            width: 60px;
            height: 60px;
            margin-right: 5px;
        }

        .smaller-icon {
            width: 45px;
            height: 45px;
            margin-left: 5px;
            margin-right: 15px;
        }
        .relation-service-content {
            .title {
                height: 22px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 22px;
                color: #191c3d;
            }
            .des {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                opacity: 0.6;
                margin-top: 8px;
            }
            .price {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #ef2323;
                margin-top: 4px;
            }
        }
    }
}
</style>
